export default __webpack_public_path__ + "static/media/debate_1.d7a46fd1.JPG";